module.exports = __webpack_public_path__ + "static/media/Toki-Logo-1.41fc1e8c.jpg";